import { Component, Input, OnInit } from '@angular/core';
import { ResizeEvent } from 'angular-resizable-element';
import { IMapPin } from '../bing-map/typings/models';

@Component({
    selector: 'cl-resizable-map',
    styleUrls: ['./resizable-map.component.scss'],
    templateUrl: './resizable-map.component.html',
})
export class ResizableMapComponent implements OnInit {
    public static $name = 'clResizableMap';

    @Input() public height: number;
    @Input() public pins: IMapPin[];
    @Input() public customBtn: any;

    mapHeight?: number;

    ngOnInit() {
        this.mapHeight = this.height;
    }

    onResizeEnd(event: ResizeEvent) {
        this.mapHeight = event.rectangle.height;
    }
}